import '@module/LoadingOverlay/loading_overlay.scss';
import { documentReady, qs, qsa } from '@js/utils/toolbox';

class LoadingOverlay {
	constructor () {
		this.elements = {
			wrapper: document.querySelector('.abLoadingOverlay__loading')
		};
	}

	loadImages () {
		if (!this.elements.wrapper) {
			return;
		}
		const picture = qs('picture', this.elements.wrapper);
		if (!picture) {
			return;
		}

		const sources = qsa('source[data-srcset]', picture);
		sources.forEach((el) => {
			el.srcset = el.dataset.srcset;
			el.removeAttribute('data-srcset');
		});

		const img = qs('img[data-src]', picture);
		if (!img) {
			return;
		}
		img.src = img.dataset.src;
		img.removeAttribute('data-src');
	}

	show () {
		window.scroll(0, 0);
		document.body.classList.add('modal-open');
		this.elements.wrapper.style.display = 'block';
	}

	hide () {
		document.body.classList.remove('modal-open');
		this.elements.wrapper.style.display = 'none';
	}
}

export const loadingOverlay = new LoadingOverlay();

documentReady(() => {
	loadingOverlay.loadImages();
});
